
<h2>{{ 'settings.templates' | transloco }}</h2>

<div class="config-row">
  <div class="ui toggle checkbox config-toggle" (click)="toggleConfigExportMode()">
    <input type="checkbox"  [ngModel]="configExportMode"/>
    <label>{{ 'settings.export-config-mode' | transloco }}</label>
  </div>
</div>

<div class="template-filters">
  <div class="template-year-filter">
    @if (taxYear) {
<app-search-dropdown
      label="{{yearLabel}}" [formGroup]="searchForm" [formCtrl]="taxYear"
      [listOptions]="taxYearOptions">
    </app-search-dropdown>
}
  </div>
  @if (!configExportMode) {
<div class="template-keyword-filter">
    <div class="ui left fluid input">
      <i class="search icon template-input-icon"></i>
      <input type="text" [(ngModel)]="templateSearch" placeholder="Search Templates" />
    </div>
  </div>
}
  @if (!configExportMode) {
<div class="template-actions">
    @if (!isProductionMode) {
<button class="ui basic button tiny" (click)="updateTemplateType()">{{ 'settings.add-template-type' | transloco }}</button>
}
    <button class="ui primary background button tiny" (click)="openTemplateUploadModal()">{{ 'settings.upload-template' | transloco }}</button>
  </div>
}
  @if (configExportMode) {
<div class="config">
    @if (configExportMode) {
<div class="config-date">
      <input type="date" placeholder="From date" [(ngModel)]="configExportDate"
        (change)="loadTemplateTypesForConfigExport()">
    </div>
}

    @if (configExportMode) {
<button class="ui primary button background tiny config-button"
      (click)="openConfigExportConfimationModal()">{{ 'settings.download-config' | transloco }}</button>
}
  </div>
}
</div>

@if (templates?.length == 0 && !configExportMode) {
<p >{{ 'settings.no-templates-found' | transloco }}</p>
}
@if (showYearError && !taxYear.value.value) {
<p>{{ 'settings.must-select-a-year' | transloco }}</p>
}

@if (templates?.length > 0 && !configExportMode) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th>{{ 'settings.template-type' | transloco }}</th>
      <th>{{ 'settings.module' | transloco }}</th>
      <th>{{ 'settings.group' | transloco }}</th>
      <th>{{ 'settings.order' | transloco }}</th>
      <th>{{ 'settings.file-name' | transloco }}</th>
      <th>{{ 'settings.file-type' | transloco }}</th>
      @if (!isProductionMode) {
<th></th>
}
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (template of templates | keyWord: ['type', 'filename', 'fileType']:templateSearch; track template) {
<tr>
      <td>{{ template.templateType.templateType }}</td>
      <td>{{ moduleMap.get(template.templateType.module) }}</td>
      <td>{{ groupMap.get(template.templateType.templateGroup) }}</td>
      <td>{{ template.templateType.templateOrder }}</td>
      <td class="type">{{ template.filename }}</td>
      <td>{{ template.fileType }}</td>
      @if (!isProductionMode) {
<td class="edit" align="right" (click)="updateTemplateType(template.templateType)">{{ 'settings.edit' | transloco }}</td>
}
      <td class="edit" align="right" (click)="openTemplateViewModal(template.templateType.templateType, template.year)">{{ 'settings.versions' | transloco }}</td>
    </tr>
}
  </tbody>
</table>
}

@if (configExportMode && templateTypesForConfigExport?.length == 0) {
<p >{{ 'settings.no-templates' | transloco }}</p>
}

@if (configExportMode && templateTypesForConfigExport?.length) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th>
        <div class="ui checkbox">
          <input type="checkbox" [(ngModel)]="entireListSelected" (change)="entireListSelection()" /><label>&nbsp;</label>
        </div>
      </th>
      <th>{{ 'settings.template-type' | transloco }}</th>
      <th>{{ 'settings.module' | transloco }}</th>
      <th>{{ 'settings.group' | transloco }}</th>
      <th>{{ 'settings.order' | transloco }}</th>
      <th>{{ 'settings.created' | transloco }}</th>
      <th>{{ 'settings.updated' | transloco }}</th>
    </tr>
  </thead>
  <tbody>
    @for (templateType of templateTypesForConfigExport; track templateType) {
<tr>
      <td>
        <div class="ui checkbox">
          <input type="checkbox" [(ngModel)]="templateType.selected" (change)="listSelection()" /><label>&nbsp;</label>
        </div>
      </td>
      <td>{{ templateType.templateType }}</td>
      <td>{{ templateType.module }}</td>
      <td>{{ templateType.templateGroup }}</td>
      <td>{{ templateType.templateOrder }}</td>
      <td>{{ templateType.displayCreatedAt }}</td>
      <td>{{ templateType.displayUpdatedAt }}</td>
    </tr>
}
  </tbody>
</table>
}

<div #templateViewModal id="template-view-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <h1>{{ 'settings.template-list' | transloco }}</h1>
  <p>{{ 'settings.click-the-row-to-activate-the-template' | transloco }}</p>
  <form>
    <div class="content scroll-table">
      @if (templatesByYearByType?.length > 0) {
<table class="ui striped table" width="100%" cellspacing="0">
        <thead>
          <tr class="view-modal-title">
            <th>{{ 'settings.template-type' | transloco }}</th>
            <th>{{ 'settings.file-name' | transloco }}</th>
            <th>{{ 'settings.file-type' | transloco }}</th>
            <th>{{ 'settings.upload-time' | transloco }}</th>
            <th>{{ 'settings.activate' | transloco }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (t of templatesByYearByType; track t) {
<tr class="selectable"
            [ngClass]="{ selected: t.active }">
            <td>{{ t.templateType.templateType }}</td>
            <td class="type">{{ t.filename }}</td>
            <td>{{ t.fileType }}</td>
            <td>{{ t.createdAt }}</td>
            <td (click)="updateTemplateActivity(t)" class="edit">
              <input type="radio" name="activeTemplate" style="margin-bottom: 0" class="edit" [checked]="t.active" />
            </td>
            <td><img class="edit" src="assets/rubix-documents/file_download_24dp.svg" (click)="downloadTemplate(t.location)" alt="download"/></td>
          </tr>
}
        </tbody>
      </table>
}
    </div>
  </form>
</div>

<div #templateUploadModal id="template-upload-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>

  <h1>{{ 'settings.upload-template' | transloco }}</h1>

  <div id="container">
    <div>
      <div class="flex-grow"></div>

      <div class="lbl-container">
        <label>{{ 'settings.template-type' | transloco }}</label>
      </div>

      <div class="ui search selection dropdown templateTypeDropdown">
        <div (click)="showTypeDropdown = true">
          @if (showTypeDropdown) {
<input (clickOutside)="hideTypeDropdown()" [delayClickOutsideInit]="true" placeholder=""
            class="search" autocomplete="off" autofocus="true" [ngModel]="templateTypeFilter"
            (ngModelChange)="initTypeDropdown($event)" class="input-area" />
}
          @if (!showTypeDropdown) {
<div class="text">{{ type ? type : "Select a template type" }}</div>
}
          @if (showTypeDropdown) {
<div class="menu transition visible typelist">
            @for (item of typeList; track item) {

              @if (item) {
<div class="item" (click)="selectType(item)">{{ item.templateType }}</div>
}
            
}
          </div>
}
          <i class="chevron down icon"></i>
        </div>
      </div>
    </div>

    <div>
      <div class="flex-grow"></div>

      <div class="file-upload" title="{{ !type ? 'Please select a template type from the dropdown' : undefined }}">
        <input #uploadFile type="file" class="list-upload-btn" (change)="initFile($event.target.files)"
          [ngClass]="{ disabled: !type }" />
      </div>
    </div>

    <div>
      <div class="flex-grow"></div>

      <div class="upload-footer" title="{{ !sourceFile ? 'Please upload a source file' : undefined }}">
        <button (click)="uploadTemplate()" class="ui primary background button"
          [ngClass]="{ loading: isLoading, disabled: !type || !sourceFile }">{{ 'settings.upload' | transloco }}</button>
      </div>
    </div>
  </div>
</div>

<div #configExportConfimationModal class="ui tiny modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>{{ 'settings.please-confirm-the-selected-config-to-export' | transloco }}</p>
  <table class="ui striped table">
    <thead>
      <tr class="view-modal-title">
        <th>{{ 'settings.template-type' | transloco }}</th>
        <th>{{ 'settings.updated' | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (templateType of selectedTemplateTypes; track templateType) {
<tr>
        <td>{{ templateType.templateType }}</td>
        <td>{{ templateType.displayUpdatedAt }}</td>
      </tr>
}
    </tbody>
  </table>
  @if (!selectedTemplateTypes.length) {
<p>{{ 'settings.nothing-selected' | transloco }}</p>
}
  <button class="ui primary button background tiny config-button"
   [ngClass]="{disabled: !selectedTemplateTypes.length}" (click)="downloadConfig()">{{ 'settings.download' | transloco }}</button>
</div>

<div #msgModal id="success-modal" class="ui tiny modal">

  <div class="icon modal-close close"></div>

  <div class="content">

    <div class="icon" [ngClass]="{ 'green-success': !bulkAddTemplate?.error, 'red-error': bulkAddTemplate?.error }">
    </div>
    <h3>
      {{ bulkAddTemplate?.message }}
      {{ bulkAddTemplate?.error && "Incorrect file setup" }}
    </h3>

    <h3>{{ bulkAddTemplate?.error?.message }}</h3>

  </div>

  <div class="actions">
    <div class="ui primary background button approve">{{ 'settings.ok' | transloco }}</div>
  </div>

</div>
